export const NOTIFICATION_TOGGLE_CONFIG = [
  {
    key: 'invoiceApprovals',
    label: 'Invoice approvals',
    description: 'Get notified when invoices are approved',
    defaultValue: true
  },
  {
    key: 'invoiceRejections',
    label: 'Invoice rejections',
    description: 'Get notified when invoices are rejected',
    defaultValue: true
  },
  {
    key: 'chatMessages',
    label: 'Chat messages',
    description: 'Get notified of new chat messages',
    defaultValue: true
  },
  {
    key: 'paymentConfirmations',
    label: 'Payment confirmations',
    description: 'Get notified when payments are confirmed',
    defaultValue: true
  },
  {
    key: 'systemUpdates',
    label: 'System updates',
    description: 'Get notified of system updates and maintenance',
    defaultValue: false
  }
];

export const NOTIFICATION_DEFAULTS = NOTIFICATION_TOGGLE_CONFIG.reduce((acc, { key, defaultValue }) => {
  acc[key] = defaultValue;
  return acc;
}, {});

export const NOTIFICATION_TYPE_TO_PREFERENCE = {
  invoice_received: 'invoiceApprovals',
  invoice_created: 'invoiceApprovals',
  invoice_approved: 'invoiceApprovals',
  invoice_rejected: 'invoiceRejections',
  invoice_paid: 'paymentConfirmations',
  payment_sent: 'paymentConfirmations',
  invoice_payment: 'paymentConfirmations',
  invoice_refunded: 'paymentConfirmations',
  payment_success: 'paymentConfirmations',
  payment_received: 'paymentConfirmations',
  system_update: 'systemUpdates',
  system: 'systemUpdates',
  chat_message: 'chatMessages',
  new_message: 'chatMessages'
};

export const getNotificationMeta = (key) =>
  NOTIFICATION_TOGGLE_CONFIG.find((toggle) => toggle.key === key);

export const normalizeNotificationPreferences = (preferences = {}) => {
  const normalized = { ...NOTIFICATION_DEFAULTS };
  for (const key of Object.keys(NOTIFICATION_DEFAULTS)) {
    if (Object.prototype.hasOwnProperty.call(preferences, key)) {
      normalized[key] = Boolean(preferences[key]);
    }
  }
  return normalized;
};

export const shouldAllowNotification = (preferences = {}, type) => {
  if (!type) {
    return true;
  }
  const preferenceKey = NOTIFICATION_TYPE_TO_PREFERENCE[type];
  if (!preferenceKey) {
    return true;
  }
  const effectivePreferences = normalizeNotificationPreferences(preferences);
  return effectivePreferences[preferenceKey] !== false;
};

